// Utilitaires partagés pour les conversations (client + admin)

// Fusionne des messages entrants avec l'existant :
// - déduplique par id (client_id côté serveur = id local)
// - COMPLÈTE un message existant quand la version entrante a plus de données
//   (ex. fileUrl arrivant du serveur alors que localStorage n'a que fileName)
// - trie chronologiquement
export const mergeMessages = (prev, incoming) => {
  const merged = new Map();
  prev.forEach(m => merged.set(String(m.id), m));
  let changed = false;
  incoming.forEach(m => {
    const key = String(m.id);
    const existing = merged.get(key);
    if (!existing) {
      merged.set(key, m);
      changed = true;
      return;
    }
    const patch = {};
    for (const field of ['fileUrl', 'fileData', 'fileName', 'fileType', 'status', 'created_at', 'content']) {
      if (m[field] && !existing[field]) patch[field] = m[field];
    }
    if (Object.keys(patch).length) {
      merged.set(key, { ...existing, ...patch });
      changed = true;
    }
  });
  if (!changed) return prev;
  return [...merged.values()].sort(
    (a, b) => new Date(a.timestamp || a.created_at) - new Date(b.timestamp || b.created_at)
  );
};

// L'utilisateur est-il près du bas de la conversation ?
export const isNearBottom = (el, threshold = 120) =>
  !el || el.scrollHeight - el.scrollTop - el.clientHeight < threshold;

// Fait défiler UNIQUEMENT le conteneur du chat (pas la page entière).
// Marque le scroll comme "programmatique" pour que handleScroll ignore
// les positions intermédiaires de l'animation smooth.
export const scrollChatToEnd = (ref, smooth = true, flagRef = null) => {
  const el = ref?.current;
  if (!el) return;
  if (flagRef) flagRef.current = true;
  el.scrollTo({ top: el.scrollHeight, behavior: smooth ? 'smooth' : 'auto' });
  if (!smooth && flagRef) flagRef.current = false;
};

export const formatTime = (timestamp) => {
  if (!timestamp) return '';
  return new Date(timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
};

export const formatDate = (timestamp) => {
  if (!timestamp) return '';
  return new Date(timestamp).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};
